// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom-select-format-group-label--gRW2i{padding:5px 0}.custom-select-format-group-label--gRW2i>span{font-size:10px;font-weight:normal}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"custom-select-format-group-label": "custom-select-format-group-label--gRW2i"
};
export default ___CSS_LOADER_EXPORT___;
